"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = require("react-jss");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _ClientScript = _interopRequireDefault(require("@aetn/ui-core/Html/ClientScript"));

var _ConsentBanner = _interopRequireDefault(require("./ConsentBanner.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CCPABanner = function CCPABanner(_ref) {
  var classes = _ref.classes,
      runtimeEnv = _ref.runtimeEnv,
      country = _ref.country,
      state = _ref.state;
  var countryQuery = country && "&country=".concat(country);
  var stateQuery = state && "&state=".concat(state);
  var trustArcDomain = runtimeEnv === 'prod' ? 'aenetworks.com' : 'aenetworkstest.com';

  if (_jsCookie["default"].get('Country-Code') !== 'US') {
    // The domain should be generic and trustarc will change it in a few days to be something more generic.
    trustArcDomain = runtimeEnv === 'prod' ? 'historycon.com' : 'historycontest.com';
  }

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    id: "consent_blackbar",
    className: classes.root
  }), _react["default"].createElement(_ClientScript["default"], {
    src: "//consent.trustarc.com/notice?domain=".concat(trustArcDomain, "&c=teconsent&text=true").concat(countryQuery).concat(stateQuery, "&js=nj&noticeType=bb")
  }));
};

CCPABanner.propTypes = {
  classes: _propTypes["default"].object,
  runtimeEnv: _propTypes["default"].string,
  country: _propTypes["default"].string,
  state: _propTypes["default"].string
};
CCPABanner.defaultProps = {
  classes: {},
  runtimeEnv: 'prod',
  country: '',
  state: ''
};

var _default = (0, _ConsentBanner["default"])((0, _reactJss.withTheme)(CCPABanner));

exports["default"] = _default;